import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-logo">
          <Link to="/">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/gnp-logo01.webp`} 
              alt="Gardens of North Port" 
              className="logo-image"
            />
          </Link>
        </div>

        <ul className="navbar-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/#care-options">Care Options</Link></li>
          <li><Link to="/#amenities">Amenities</Link></li>
          <li><Link to="/#residences">Residences</Link></li>
          <li><Link to="/#testimonials">Testimonials</Link></li>
        </ul>

        <div className="navbar-cta">
          <span className="navbar-phone-text">(941) 249-2344</span>
          <a href="tel:9412492344" className="navbar-phone-btn" aria-label="Call us">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.6 10.8C7.8 13.2 9.8 15.2 12.2 16.4L14.1 14.5C14.35 14.25 14.7 14.18 15 14.32C16.05 14.7 17.2 14.9 18.4 14.9C18.9 14.9 19.3 15.3 19.3 15.8V18.4C19.3 18.9 18.9 19.3 18.4 19.3C10.3 19.3 3.7 12.7 3.7 4.6C3.7 4.1 4.1 3.7 4.6 3.7H7.2C7.7 3.7 8.1 4.1 8.1 4.6C8.1 5.8 8.3 6.95 8.68 8C8.82 8.3 8.75 8.65 8.5 8.9L6.6 10.8Z" fill="currentColor" />
            </svg>
          </a>
        </div>
      </nav>

      <div className="terms-container">
        <Link to="/" className="back-to-home">← Back to Home</Link>
        
        <h1>Terms & Conditions</h1>
        <p className="last-updated">Last Updated: April 2026</p>
        
        <div className="terms-content">
          <p>
            Welcome to the Gardens of North Port website. By accessing or using this site, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use this website.
          </p>
          <p>
            These Terms apply to all visitors, users, and anyone accessing this website.
          </p>

          <h2>1. About This Website</h2>
          <p>This website is operated for:</p>
          <p className="address-block">
            <strong>Gardens of North Port</strong><br />
            4900 S Sumter Blvd<br />
            North Port, FL 34287<br />
            Phone: (941) 249-2344<br />
            FL License #10843 · Part of North Port Retirement Centers
          </p>
          <p>
            This website provides general information about our community, care options (Independent Living, Assisted Living, In-Home Medical Care), amenities, residences, tours, and contact details.
          </p>
          <p>
            The content on this site is not intended as medical, legal, or financial advice.
          </p>

          <h2>2. Informational Use Only</h2>
          <p>
            All information on this website including services, residences, amenities, pricing, and testimonials is for informational purposes only.
          </p>
          <p>Details such as:</p>
          <ul>
            <li>Residence availability and floor plans</li>
            <li>Services and care options</li>
            <li>Pricing and promotions</li>
            <li>Activities and schedules</li>
          </ul>
          <p>may change at any time without prior notice.</p>
          <p>Please contact us directly to confirm current information before making decisions.</p>

          <h2>3. No Medical or Professional Advice</h2>
          <p>Nothing on this website is intended to:</p>
          <ul>
            <li>Diagnose or treat medical conditions</li>
            <li>Replace advice from licensed professionals</li>
            <li>Serve as legal or financial guidance</li>
          </ul>
          <p>Always consult qualified professionals and family members before making care decisions.</p>

          <h2>4. Eligibility and Appropriate Use</h2>
          <p>This website is intended for adults researching senior living options.</p>
          <p>By using this site, you agree to:</p>
          <ul>
            <li>Use it only for lawful purposes</li>
            <li>Not interfere with website functionality or security</li>
            <li>Not submit false or misleading information</li>
          </ul>
          <p>We reserve the right to restrict access in case of misuse.</p>

          <h2>5. Contact Forms, Tour Requests & Newsletter</h2>
          <h3>Tour and Contact Requests</h3>
          <p>By submitting forms or contacting us, you authorize us to reach you via:</p>
          <ul>
            <li>Phone calls</li>
            <li>Emails</li>
            <li>Text messages (where applicable)</li>
          </ul>
          <p>This is for scheduling tours, answering inquiries, and sharing relevant information.</p>
          <p>Submitting a form does not guarantee residency or placement.</p>

          <h2>6. Testimonials and Reviews</h2>
          <p>Testimonials and reviews on the website:</p>
          <ul>
            <li>Reflect individual experiences</li>
            <li>Do not guarantee similar outcomes</li>
            <li>May be edited for clarity</li>
          </ul>
          <p>Ratings from platforms like Google or Facebook may change over time.</p>

          <h2>7. Intellectual Property</h2>
          <p>All website content including text, images, logos, and design is owned or licensed by Gardens of North Port.</p>
          <p>You may:</p>
          <ul>
            <li>View and print content for personal, non-commercial use</li>
          </ul>
          <p>You may not:</p>
          <ul>
            <li>Copy, reproduce, or distribute content for commercial purposes</li>
            <li>Use branding without permission</li>
          </ul>

          <h2>8. Third-Party Links and Services</h2>
          <p>This website may include links to third-party platforms such as:</p>
          <ul>
            <li>Social media (Facebook, Instagram)</li>
            <li>Maps and external resources</li>
          </ul>
          <p>We are not responsible for their content or policies. Use them at your own risk.</p>

          <h2>9. Privacy</h2>
          <p>Your use of this website is also governed by our Privacy Policy.</p>
          <p>By using this site, you agree to how we collect and use your information as outlined in that policy.</p>

          <h2>10. Disclaimer of Warranties</h2>
          <p>This website is provided "as is" and "as available."</p>
          <p>We do not guarantee:</p>
          <ul>
            <li>Continuous availability</li>
            <li>Error-free performance</li>
            <li>Complete accuracy of information</li>
          </ul>
          <p>Use of the website is at your own risk.</p>

          <h2>11. Limitation of Liability</h2>
          <p>To the extent permitted by law, Gardens of North Port and its affiliates are not liable for:</p>
          <ul>
            <li>Indirect or consequential damages</li>
            <li>Losses from website use</li>
            <li>Decisions based on website information</li>
          </ul>

          <h2>12. Changes to These Terms</h2>
          <p>We may update these Terms & Conditions at any time.</p>
          <p>Changes will be reflected in the "Last Updated" date. Continued use of the site means acceptance of the updated terms.</p>

          <h2>13. Contact Us</h2>
          <p>For any questions regarding these Terms & Conditions:</p>
          <p className="address-block">
            <strong>Gardens of North Port</strong><br />
            4900 S Sumter Blvd<br />
            North Port, FL 34287<br />
            Phone: (941) 249-2344
          </p>
          <p>We are happy to assist you with any queries.</p>
        </div>
      </div>

      <footer className="custom-footer">
        <div className="custom-footer-main">
          {/* About */}
          <div>
            <h2>About Gardens of North Port</h2>
            <p>
              Gardens of North Port is a caring senior living community where comfort, dignity, and connection come together in a beautiful North Port setting. With thoughtfully prepared meals, welcoming residences, enriching activities, and attentive support, we help residents enjoy a safer, more joyful everyday life.
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h2>Contact Information</h2>
            <div>Phone: (941) 249-2344</div>
            <div>Location: North Port, Florida</div>
          </div>

          {/* Information */}
          <div>
            <h2>Information</h2>
            <div><Link to="/privacy-policy">Privacy Policy</Link></div>
            <div><Link to="/terms-and-conditions">Terms &amp; Condition</Link></div>
          </div>
        </div>
        <hr />
        <div className="custom-footer-bottom">
          <div>
            © 2026 Gardens of North Port. All rights reserved. FL Lic. #10843. Located at 4900 S Sumter Blvd, North Port, FL 34287. This website is provided for general informational purposes only. Community services, amenities, residence availability, and care options may change without notice. Images and descriptions are representative and may vary. By submitting your information, you consent to being contacted by our team regarding tours, services, and availability.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
